import { GroupIds } from "@/configuration/group-ids";
import { Classification } from "@/src/models/constants/classifications";
import { Group } from "@/src/models/group";

const SPLIT_CONFIDENCE_THRESHOLD = 0.6;
const SPLIT_CONFIDENCE_THRESHOLD_HIGH = 0.9;

export const Workflow = {
  REFERRAL: "referral",
  PRIOR_AUTHORIZATION: "prior_authorization",
  UPLOAD: "upload",
  DOC_MANAGEMENT: "doc_management",
  LEAD_FORM: "lead_form",
} as const;

export type WorkflowType = (typeof Workflow)[keyof typeof Workflow];

export const DefaultWorkflow: Partial<Record<WorkflowType, Classification[]>> = {
  [Workflow.REFERRAL]: [
    Classification.INTAKE,
    Classification.REFERRAL,
    Classification.REFERER_INFORMATION,
    Classification.RESPONSE_TO_VH_REQUEST,
  ],
};

/**
 * Returns the split confidence threshold for a given group
 *
 * @param group - The group to get the split confidence threshold for
 * @returns The split confidence threshold for the given group
 */
export function getSplitConfidenceThreshold(group: Group) {
  if (
    group.id === GroupIds.PINNACLE_MEDICAL_GROUP_LIVE ||
    group.id === GroupIds.PINNACLE_MEDICAL_GROUP_LIVE_SANDBOX ||
    group.id === GroupIds.COUG_LIVE
  ) {
    return SPLIT_CONFIDENCE_THRESHOLD_HIGH;
  }

  return SPLIT_CONFIDENCE_THRESHOLD;
}
